module.exports = __webpack_public_path__ + "static/media/balsamiq.1b551b4b.png";